import request, { ResponsePageableData } from '@/libs/request'

//获取金额退款列表
export const getBalanceRefundList = (data?) => request<ResponsePageableData>({ url: '/adminapi/UserBalanceRefund/getBalanceRefundList', data })

// 向后台提交状态
export const auditBalanceRefund = (data?) => request<ResponsePageableData>({ url: 'adminapi/UserBalanceRefund/auditBalanceRefund', data })
